import DsfAuditState from './auditState.vue'
//已经在路由中引入不必此处再引入
// import DsfStatsAuditFormulaForm from './formulaForm.vue'

const components = {
  DsfAuditState,
  // DsfStatsAuditFormulaForm
}

function install(Vue) {
  for (let key in components) {
    let it = components[key];
    Vue.component(it.name, it);
    if (!window.$components['platform']) {
      window.$components['platform'] = {}
    }
    window.$components['platform'][it.name] = it;
  }
}

export { install };
export default install;